import React from "react";
import { Image } from "../../../../../../components/Image";
import "./style.css";

export const SectionComponentNode = () => {
  return (
    <div className="section-component-node">
      <header className="header">
        <p className="title-2">
          <span className="text-wrapper-11">Guaranteed </span>

          <span className="text-wrapper-12">Safe</span>

          <span className="text-wrapper-11"> Checkout</span>
        </p>

        <Image src="/static/image/questionnaire/fasting/payScreen/icon-6.png" alt="Icon" className="icon-3" />
      </header>

      <Image src="/static/image/questionnaire/fasting/payScreen/img-5.png" alt="Img" className="img-4" />
    </div>
  );
};
